<template>
    <div class="d-flex align-items-start flex-column gap-3">
        <div class="time-periods">
            <div role="button"
                v-for="item in periodTimes"
                :class="['item', {'selected': item.value === selectedPeriod?.value}]"
                @click="periodTimeClicked(item)">
                <h4 class="mb-0" v-html="item.value"></h4>
                <p class="mb-0" v-html="trans(`general.select_period.${item.type}`)"></p>
            </div>
            <div :class="['item custom', {'selected': selectedPeriod?.value === 'custom'}]" role="button"
                @click="periodTimeClicked({ type: 'custom', value: 'custom' })">
                <label class="text-wrap p-2" v-html="trans(`general.select_period.set_time`)"></label>
            </div>
        </div>
        <p class="text-gray-700 small" v-html="formattedExplanation"
            v-if="showExplanation && selectedPeriod && selectedPeriod?.value !== 'custom'"></p>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "BasicTimePeriod",
    props: {
        selected: {
            type: Object,
            required: false,
            default: null,
        },
        periodTimes: {
            type: Array,
            required: false,
            default: () => [
                {
                    type: 'minutes',
                    value: 15,
                },
                {
                    type: 'minutes',
                    value: 30,
                },
                {
                    type: 'minutes',
                    value: 45,
                },
                {
                    type: 'hour',
                    value: 1,
                },
                {
                    type: 'hours',
                    value: 1.5,
                },
                {
                    type: 'hours',
                    value: 2,
                }
            ],
        },
        showExplanation: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            time: {
                from: null,
                to: null,
            },
            selectedPeriod: this.selected,
        };
    },
    watch: {
        selectedPeriod: {
            handler(value) {
                this.$emit('select', {
                    selected: value,
                    from: this.time?.from,
                    to: this.time?.to,
                });
            },
            deep: true,
        },
    },
    computed: {
        formattedExplanation() {
            const fromTime = this.time.from ? moment(this.time.from).format('LT') : '';
            const toTime = this.time.to ? moment(this.time.to).format('LT') : '';
            return this.trans('general.select_period.explanation', { from: fromTime, to: toTime });
        },
    },
    methods: {
        periodTimeClicked(item) {
            this.time.from = null;
            this.time.to = null;

            if (this.selectedPeriod && this.selectedPeriod?.value === item.value) {
                this.selectedPeriod = null;
                return;
            }

            if (item.type === 'custom') {
                this.selectedPeriod = {
                    type: 'custom',
                    value: 'custom',
                };
                return;
            }

            this.selectedPeriod = item;
            const type = item.type === 'hour' ? 'hours' : item.type;
            this.time.from = moment().subtract(item.value, type).format('YYYY-MM-DD HH:mm:ss');
            this.time.to = moment().format('YYYY-MM-DD HH:mm:ss');
        },
    }
}
</script>
